/*
  Do not edit directly
  Generated on Wed, 03 Jun 2020 10:45:44 GMT
*/

const lnNectar = {
  color: {
    palette: {
      black: "#000000",
      blue60: "#00A9CF",
      brand1: "#8520F7",
      brand1Highlight: "#771AE0",
      brand2: "#8520F7",
      brand2Highlight: "#771AE0",
      green60: "#00D999",
      grey100: "#0D0B11",
      grey90: "#26212F",
      grey80: "#3F384C",
      grey70: "#585068",
      grey60: "#726A82",
      grey50: "#8B839B",
      grey40: "#A49DB3",
      grey30: "#BEB8CA",
      grey20: "#D8D4E0",
      grey10: "#F2F1F5",
      orange60: "#F06C00",
      orange70: "#E55000",
      red: "#FF6D4F",
      aqua: "#00A9CF",
      green: "#00D999",
      yellow: "#FFB900",
      blue: "#00A9CF",
      red60: "#FF6D4F",
      white: "#FFFFFF",
      yellow60: "#FFB900",
      brand3: "#00D999",
      brand3Highlight: "#33C497",
      brand4: "#FFB900",
      brand4Highlight: "#F5A300",
      green70: "#33C497",
      green80: "#004852",
      green90: "#00383F",
      purple: "#8520F7",
      purpleDark: "#771AE0",
      purpleDarker: "#38005B",
      purpleDarkest: "#25003C",
      yellowDark: "#F5A300",
      yellowDarker: "#631F00",
      yellowDarkest: "#521A00",
      redDark: "#EF6043",
      redDarker: "#6A001C",
      redDarkest: "#570017",
      greenDark: "#33C497",
      greenDarker: "#004852",
      greenDarkest: "#00383F",
      putty: "#F3F0EC",
      purple90: "#25003C",
      purple80: "#38005B",
      purple70: "#771AE0",
      purple60: "#8520F7",
      putty60: "#F3F0EC",
      red70: "#EF6043",
      red80: "#6A001C",
      red90: "#570017",
      yellow70: "#F5A300",
      yellow80: "#631F00",
      yellow90: "#521A00"
    },
    monochrome: {
      white: "#FFFFFF",
      lighter: "#F2F1F5",
      light: "#D8D4E0",
      medium: "#726A82",
      dark: "#3F384C",
      darker: "#26212F",
      greyVLight: "#F2F1F5",
      greyLight: "#D8D4E0",
      grey: "#8B839B",
      greyDark: "#3F384C",
      greyDarker: "#26212F",
      black: "#000000"
    },
    scheme: {light: "#000000", dark: "#FFFFFF", brand1: "#FFFFFF", brand2: "#570017", brand3: "#FFFFFF", brand4: "#FFFFFF"},
    semantic: {
      success: "#26212F",
      info: "#26212F",
      warning: "#26212F",
      error: "#26212F",
      successBase: "#FFFFFF",
      infoBase: "#FFFFFF",
      warningBase: "#FFFFFF",
      errorBase: "#FFFFFF"
    }
  },
  mode: {
    dark: {
      background: "#26212F",
      base: "#F2F1F5",
      baseInverse: "#3F384C",
      border: "#3F384C",
      footerBackground: "#FFFFFF",
      footerText: "#3F384C",
      foreground: "#26212F",
      headerBackground: "#26212F",
      headerText: "#F2F1F5",
      highlight: "#FFFFFF",
      highlightInverse: "#000000"
    },
    default: {
      background: "#F3F0EC",
      base: "#3F384C",
      baseInverse: "#3F384C",
      border: "#726A82",
      footerBackground: "#26212F",
      footerText: "#F2F1F5",
      foreground: "#FFFFFF",
      headerBackground: "#FFFFFF",
      headerText: "#3F384C",
      highlight: "#000000",
      highlightInverse: "#000000"
    }
  },
  surface: {
    light: {background: "#F2F1F5", base: "#3F384C", border: "#D8D4E0", highlight: "#000000"},
    white: {background: "#FFFFFF", base: "#3F384C", border: "#D8D4E0", highlight: "#000000"},
    dark: {background: "#26212F", base: "#F2F1F5", border: "#3F384C", highlight: "#FFFFFF"},
    grey: {background: "#26212F", base: "#F2F1F5", border: "#3F384C", highlight: "#000000"}
  },
  modifier: {
    border: {width: "2px", widthLarge: "4px", radius: "12px", radiusLarge: "24px"},
    button: {border: "2px"},
    focusRing: {focusWidth: "3px", color: "#00A9CF"},
    footer: {background: "#FFFFFF", text: "#26212F"},
    header: {background: "#FFFFFF", backgroundDark: "#000000"},
    globalBar: {height: "36px"},
    transition: {duration: "0.2s", durationLong: "0.4s", timingFunction: "ease-out"}
  },
  opacity: {default: {"": "0.7"}, light: {"": "0.15"}, disabled: {"": "0.35"}, background: {"": "0.08"}},
  overlay: {color: {"": "#000000"}, opacity: {"": "0.7"}},
  space: {
    baseline: {grid: 8, condensed: 4},
    fixedWidth: {extraSmall: 800, small: 1280, medium: 1440, large: 1800},
    size: {small: 24, medium: 48, large: 80},
    spacing: {default: 8, small: 8, medium: 16, large: 24, extraLarge: 32},
    breakpoints: {extraExtraSmall: 480, extraSmall: 600, small: 720, medium: 960, large: 1200, extraLarge: 1400, extraExtraLarge: 1800}
  },
  typography: {
    base: {fontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif"},
    brand: {fontFamily: "ItalianPlateNo1Expanded, 'Helvetica Neue', Helvetica, Arial, sans-serif", font: "ItalianPlateNo1Expanded", letterform: "sans-serif"},
    monospace: {
      fontFamily: "Consolas, \"Andale Mono WT\", \"Andale Mono\", \"Lucida Console\", \"Lucida Sans Typewriter\", \"DejaVu Sans Mono\", \"Bitstream Vera Sans Mono\", \"Liberation Mono\", \"Nimbus Mono L\", Monaco, \"Courier New\", Courier, monospace"
    },
    system: {
      fontFamily: "system, -apple-system, \".SFNSText-Regular\", \"San Francisco\", \"Roboto\", \"Segoe UI\", \"Helvetica Neue\", \"Lucida Grande\", sans-serif"
    },
    fontSize: {root: 16, default: 17},
    fontWeight: {light: 300, regular: 400, medium: 500, semiBold: 600, bold: 700, extraBold: 800, black: 900},
    small: {fontFamily: "Barlow, 'Helvetica Neue', Helvetica, Arial, sans-serif", font: "Barlow", letterform: "sans-serif"}
  },
  fontStack: {
    display7: {fontSize: 61, lineHeight: 76, fontWeight: 800, fontFamily: "ItalianPlateNo1Expanded, 'Helvetica Neue', Helvetica, Arial, sans-serif"},
    display6: {fontSize: 49, lineHeight: 62, fontWeight: 800, fontFamily: "ItalianPlateNo1Expanded, 'Helvetica Neue', Helvetica, Arial, sans-serif"},
    display5: {fontSize: 39, lineHeight: 50, fontWeight: 800, fontFamily: "ItalianPlateNo1Expanded, 'Helvetica Neue', Helvetica, Arial, sans-serif"},
    display4: {fontSize: 31, lineHeight: 40, fontWeight: 700, fontFamily: "ItalianPlateNo1Expanded, 'Helvetica Neue', Helvetica, Arial, sans-serif"},
    display3: {fontSize: 25, lineHeight: 32, fontWeight: 700, fontFamily: "ItalianPlateNo1Expanded, 'Helvetica Neue', Helvetica, Arial, sans-serif"},
    display2: {fontSize: 21, lineHeight: 26, fontWeight: 700, fontFamily: "ItalianPlateNo1Expanded, 'Helvetica Neue', Helvetica, Arial, sans-serif"},
    display1: {fontSize: 19, lineHeight: 26, fontWeight: 700, fontFamily: "ItalianPlateNo1Expanded, 'Helvetica Neue', Helvetica, Arial, sans-serif"},
    label: {fontSize: 17, lineHeight: 24, fontWeight: 700, fontFamily: "ItalianPlateNo1Expanded, 'Helvetica Neue', Helvetica, Arial, sans-serif"},
    body2: {fontSize: 19, lineHeight: 26, fontWeight: 400, fontFamily: "ItalianPlateNo1Expanded, 'Helvetica Neue', Helvetica, Arial, sans-serif"},
    body1: {fontSize: 17, lineHeight: 24, fontWeight: 500, fontFamily: "ItalianPlateNo1Expanded, 'Helvetica Neue', Helvetica, Arial, sans-serif"},
    caption: {fontSize: 15, lineHeight: 22, fontWeight: 500, fontFamily: "Barlow, 'Helvetica Neue', Helvetica, Arial, sans-serif"},
    button: {fontSize: 17, lineHeight: 24, fontWeight: 700, fontFamily: "ItalianPlateNo1Expanded, 'Helvetica Neue', Helvetica, Arial, sans-serif"}
  },
  base: {
    fontFamily: {
      "": "ItalianPlateNo1Expanded, Frutiger, 'Frutiger Linotype', Univers, Calibri, 'Gill Sans', 'Gill Sans MT', 'Myriad Pro', Myriad, 'DejaVu Sans Condensed', 'Liberation Sans', 'Nimbus Sans L', Tahoma, Geneva, 'Helvetica Neue', Helvetica, Arial, sans-serif"
    },
    font: {"": "ItalianPlateNo1Expanded"},
    letterform: {"": "sans-serif"}
  }
};

// Aliases 
export const lnNectarColor = {
  aqua: "#00A9CF",
  black: "#000000",
  blue: "#00A9CF",
  blue60: "#00A9CF",
  brand1: "#8520F7",
  brand1Highlight: "#771AE0",
  brand2: "#8520F7",
  brand2Highlight: "#771AE0",
  brand3: "#00D999",
  brand3Highlight: "#33C497",
  brand4: "#FFB900",
  brand4Highlight: "#F5A300",
  green: "#00D999",
  green60: "#00D999",
  green70: "#33C497",
  green80: "#004852",
  green90: "#00383F",
  greenDark: "#33C497",
  greenDarker: "#004852",
  greenDarkest: "#00383F",
  grey10: "#F2F1F5",
  grey100: "#0D0B11",
  grey20: "#D8D4E0",
  grey30: "#BEB8CA",
  grey40: "#A49DB3",
  grey50: "#8B839B",
  grey60: "#726A82",
  grey70: "#585068",
  grey80: "#3F384C",
  grey90: "#26212F",
  orange60: "#F06C00",
  orange70: "#E55000",
  purple: "#8520F7",
  purple60: "#8520F7",
  purple70: "#771AE0",
  purple80: "#38005B",
  purple90: "#25003C",
  purpleDark: "#771AE0",
  purpleDarker: "#38005B",
  purpleDarkest: "#25003C",
  putty: "#F3F0EC",
  putty60: "#F3F0EC",
  red: "#FF6D4F",
  red60: "#FF6D4F",
  red70: "#EF6043",
  red80: "#6A001C",
  red90: "#570017",
  redDark: "#EF6043",
  redDarker: "#6A001C",
  redDarkest: "#570017",
  white: "#FFFFFF",
  yellow: "#FFB900",
  yellow60: "#FFB900",
  yellow70: "#F5A300",
  yellow80: "#631F00",
  yellow90: "#521A00",
  yellowDark: "#F5A300",
  yellowDarker: "#631F00",
  yellowDarkest: "#521A00"
};
export const lnNectarMonochrome = ["#FFFFFF", "#F2F1F5", "#D8D4E0", "#726A82", "#3F384C", "#26212F", "#F2F1F5", "#D8D4E0", "#8B839B", "#3F384C", "#26212F", "#000000"];
export const lnNectarFont = {base: "Arial, Helvetica Neue, Helvetica, sans-serif", brand: "ItalianPlateNo1Expanded, 'Helvetica Neue', Helvetica, Arial, sans-serif"};
export const lnNectarFontSize = {default: 16, scale: [15, 17, 19, 21, 25, 31, 39, 49, 61]};
export const lnNectarFontWeight = {light: 300, regular: 400, medium: 500, semiBold: 600, bold: 700, extraBold: 800, black: 900};
export const lnNectarSpace = {base: 8, scale: [8, 16, 24, 32]};
export const lnNectarSize = {small: 24, medium: 48, large: 80};
export const lnNectarBaseline = {grid: 8, condensed: 4};
export const lnNectarBreakpoint = {
  bp: {extraExtraSmall: 480, extraSmall: 600, small: 720, medium: 960, large: 1200, extraLarge: 1400, extraExtraLarge: 1800},
  scale: [480, 600, 720, 960, 1200, 1400, 1800]
};
export const lnNectarBorder = undefined;
export const lnNectarTransition = undefined;
export default lnNectar
